import TemplateGallery from "../../commonComponents/CC_templateGallery";
import SnippetsGrid from '../../components/snippetsGrid';
import { Link } from "react-router-dom";
import {linkStyle} from "../../components/helpersStyles";
import { IconButton, Tooltip } from '@mui/material';
import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';
import { useEffect } from "react";

export default function ProductHomePersAnimation() {
    useEffect(() => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, [])

    return <div>
            <CcTitle>
                Personalised Animations
            </CcTitle>
            <div className="text-ccColorDarkTeal">Turn your CRM data into beautiful, eye-catching animations with Personalised animations. Choose from different effects including typing, flashing, colour change and scrolling text.</div>
            <Link to={`/workflow/14`} style={linkStyle}> 
                <CcCreateNewSnippet className="mt-4" >Create new Personalised Animation</CcCreateNewSnippet>
            </Link>
            <div className=" mt-3 border border-gray-300 rounded-md p-1 flex flex-col gap-2">
                <CcSubSectionTitle>Start with existing Template</CcSubSectionTitle>
                <div>
                <TemplateGallery productTypeId={14} />
                </div>
            </div>

            <CcSubSectionTitle className=" mt-6">Latest Personalised Animations Elements</CcSubSectionTitle>
            <SnippetsGrid productTypeId={14}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}